import {
  AuthFormPanelStyled,
  AuthShellStyled,
} from '@OnArk/styles/Auth.styled';
import { InputStyled, LabelStyled } from '@OnArk/styles/Form.styled';

import { ReactNode, useEffect } from 'react';

import Link from 'next/link';

import AuthBrandPanel from '@OnArk/AuthBrandPanel';
import { secureCookie } from '@OnArk/utils/cookieSecure';
import type Cookies from 'universal-cookie';

export function AuthEmailField({ required }: { required?: boolean }) {
  return (
    <LabelStyled>
      <span>Email</span>
      <InputStyled
        name="email"
        placeholder="you@yourchurch.org"
        required={required}
        type="email"
      />
    </LabelStyled>
  );
}

function AuthLoginSwitch() {
  return (
    <p className="auth-switch">
      Already have an account?&nbsp;<Link href="/login">Log in</Link>
    </p>
  );
}

/** Sends the browser to the admin once the sign-in cookie is set. */
export function useRedirectOnTokenCookie(cookies: Cookies) {
  useEffect(() => {
    const listener = ({ name, value }: { name: string; value?: any }) => {
      if (name === 'onark-token' && value) {
        window.location.href = '/admin/classes';
      }
    };

    cookies.addChangeListener(listener);

    return () => cookies.removeChangeListener(listener);
  }, []);
}

/** Sets the sign-in cookie (`useRedirectOnTokenCookie` then redirects). */
export function setAuthCookie(
  cookies: Cookies,
  token: string | null | undefined
) {
  cookies.set('onark-token', token, { path: '/', secure: secureCookie() });
}

/** Brand panel + form panel scaffold shared by the join and reset pages. */
export function AuthFormShell({
  children,
  heading,
  headline,
  intro,
  lede,
}: {
  children: ReactNode;
  headline: string;
  heading: string;
  intro: string;
  lede: string;
}) {
  return (
    <AuthShellStyled>
      <AuthBrandPanel headline={headline} lede={lede} />
      <AuthFormPanelStyled>
        <div>
          <h2>{heading}</h2>
          <p>{intro}</p>
          {children}
          <AuthLoginSwitch />
        </div>
      </AuthFormPanelStyled>
    </AuthShellStyled>
  );
}
